
import apiRequest from './apiRequest';

const meetingApi = {
    async getAllMeetings(token) {
        const url = '/api/accounts/meetings';
        return apiRequest(url, 'GET', token);
    },
    async getMeetings(accountId, token) {
        const url = `/api/accounts/${accountId}/meetings`;
        return apiRequest(url, 'GET', token);
    },

    async createMeeting(accountId, meetingData, token) {
        const url = `/api/accounts/${accountId}/meetings`;
        return apiRequest(url, 'POST', token, meetingData);
    },

    async updateMeeting(accountId, meetingId, meetingData, token) {
        const url = `/api/accounts/${accountId}/meetings/${meetingId}`;
        return apiRequest(url, 'PUT', token, meetingData);
    },

    async deleteMeeting(accountId, meetingId, token) {
        const url = `/api/accounts/${accountId}/meetings/${meetingId}`;
        return apiRequest(url, 'DELETE', token);
    },
};

export default meetingApi;
